export { default } from "../error";
